import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpecialOpeningClosingHoursRequestCreate, SpecialOpeningClosingHoursRequestFindAll, SpecialOpeningClosingHoursRequestSearch, SpecialOpeningClosingHoursRequestUpdate } from '../../../models/api-store/special-opening-closing-hours/special-opening-closing-hours.request.model';
import { SpecialOpeningClosingHoursResponseCreate, SpecialOpeningClosingHoursResponseFindAll, SpecialOpeningClosingHoursResponseGet, SpecialOpeningClosingHoursResponseSearch, SpecialOpeningClosingHoursResponseUpdate } from '../../../models/api-store/special-opening-closing-hours/special-opening-closing-hours.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpecialOpeningClosingHoursService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.special_opening_closing_hours;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  /**createParams
       * @param objectStoresParams 
       * @returns params
       * Prende in input un oggetto e lo trasforma in un HttpParams
       */
  createParams(objectStoresParams: any) {
    let params = new HttpParams();
    for (let property in objectStoresParams) {
      if (objectStoresParams.hasOwnProperty(property)) {
        params = params.append(property, objectStoresParams[property]);
      }
    }
    return params;
  }


  findAll(request: SpecialOpeningClosingHoursRequestFindAll): Observable<SpecialOpeningClosingHoursResponseFindAll> {
    let url = this.url;
    let params = this.createParams(request);
    return this.http.get<SpecialOpeningClosingHoursResponseFindAll>(url, { params: params });
  }



  create(request: SpecialOpeningClosingHoursRequestCreate): Observable<SpecialOpeningClosingHoursResponseCreate> {
    let url = this.url;
    return this.http.post<SpecialOpeningClosingHoursResponseCreate>(url, request);
  }

  getEntity(id: number): Observable<SpecialOpeningClosingHoursResponseGet> {
    let url = this.url + "/" + id;
    return this.http.get<SpecialOpeningClosingHoursResponseGet>(url);
  }

  update(id: number, request: SpecialOpeningClosingHoursRequestUpdate): Observable<SpecialOpeningClosingHoursResponseUpdate> {
    let url = this.url + "/" + id;
    return this.http.put<SpecialOpeningClosingHoursResponseUpdate>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }


  search(request:SpecialOpeningClosingHoursRequestSearch):Observable<SpecialOpeningClosingHoursResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<SpecialOpeningClosingHoursResponseSearch>(url,request);
  }

}
